<template>
  <div>
    <transition
      appear
      enter-class="opacity-0"
      enter-active-class="transition-opacity duration-300 ease-in-out"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="transition-opacity duration-300 ease-in-out"
      leave-to-class="opacity-0"
    >
      <div class="fixed inset-0 overflow-y-auto z-1000">
        <div
          class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <!-- Backdrop -->
          <div class="fixed inset-0" aria-hidden="true">
            <div
              class="absolute inset-0 bg-gray-500 opacity-75"
              @click="closeModal"
            ></div>
          </div>
          <transition
            appear
            enter-class="opacity-0 scale-95"
            enter-active-class="transition-all duration-300 ease-in-out"
            enter-to-class="opacity-100 scale-100"
            leave-class="opacity-100 scale-100"
            leave-active-class="transition-all duration-300 ease-in-out"
            leave-to-class="opacity-0 scale-95"
          >
            <div
              class="inline-block bg-white rounded-lg overflow-hidden shadow-xl transform sm:my-8 w-full px-4 text-start"
              :class="sizeClass"
            >
              <!-- Modal header -->
              <div v-if="$slots.header || title.trim()" :class="headerClass">
                <div class="flex justify-between items-center">
                  <h3
                    id="modal.title"
                    class="text-lg leading-6 font-medium text-gray-900"
                  >
                    <slot name="header">{{ title }}</slot>
                  </h3>
                  <button
                    id="modal.close"
                    @click="closeModal"
                    class="focus:outline-none bg-transparent border-none"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>

              <!-- Modal body -->
              <div :class="bodyClass">
                <slot name="body"></slot>
              </div>

              <!-- Modal footer -->
              <div
                v-if="$slots.footer"
                :class="footerClass"
              >
                <slot name="footer"></slot>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BaseModal",

  props: {
    title: {
      type: String,
      default: "Modal",
    },
    size: {
      type: String,
      default: "medium",
      validator: (val) => ["small", "medium", "large", "xlarge"].includes(val),
    },
    bodyClass: {
      type: [String, Array, Object],
      default: ""
    },
    headerClass: {
      type: [String, Array, Object],
      default: ""
    },
    footerClass: {
      type: [String, Array, Object],
      default: ""
    },
  },

  computed: {
    sizeClass() {
      switch (this.size) {
        case "small":
          return "sm:max-w-sm";
        case "large":
          return "sm:max-w-2xl";
        case "xlarge":
          return "sm:max-w-4xl";
        default:
          return "sm:max-w-lg";
      }
    },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.text-start {
  text-align: start;
}
.z-1000 {
  z-index: 1000;
}
</style>
